import { CombinedGraphQLErrors } from '@apollo/client/errors'

export type ErrorRecoveryKind =
  'stale-client' | 'unauthenticated' | 'forbidden' | 'not-found' | 'recoverable' | 'unexpected'

const RECOVERABLE_CODES = ['VALIDATION_ERROR', 'CONFLICT', 'UNPROCESSABLE_ENTITY'] as const

export function classifyError(error: Error): ErrorRecoveryKind {
  if (!CombinedGraphQLErrors.is(error)) {
    return 'recoverable'
  }
  const code = error.errors[0]?.extensions?.code
  switch (code) {
    case 'GRAPHQL_VALIDATION_FAILED':
      return 'stale-client'
    case 'UNAUTHENTICATED':
      return 'unauthenticated'
    case 'FORBIDDEN':
      return 'forbidden'
    case 'NOT_FOUND':
      return 'not-found'
    default:
      return typeof code === 'string' && RECOVERABLE_CODES.some((candidate) => candidate === code)
        ? 'recoverable'
        : 'unexpected'
  }
}
